var map = {
	"./About/router.ts": 98,
	"./Home/router.ts": 99,
	"./Product/Manage/router.ts": 100,
	"./Product/Safety/router.ts": 101,
	"./Product/WorkPhone/router.ts": 102,
	"./Product/diy/router.ts": 103,
	"./Proxy/router.ts": 104,
	"./Solution/router.ts": 105,
	"./TestComponent/router.ts": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;